import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { ConciergeContext } from './useConcierge'

export function useConciergeId(): string {
  const { routedConciergeId } = useParams()
  const { concierge } = useContext(ConciergeContext)

  const conciergeId = routedConciergeId || concierge?.id

  if (!conciergeId) {
    throw new Error('useConciergeId is missing conciergeId')
  }
  return conciergeId
}
